import { useState, useEffect } from 'react';
import './slider.css';

import banner1 from '../assets/images/banner1.png';
import banner2 from '../assets/images/banner2.png';
import banner3 from '../assets/images/banner3.png';
import logo from '../assets/images/logo.png';
import { Link } from 'react-router-dom';

const slides = [
  {
    img: banner2,
    tipo: 'corporativo',
  },
  {
    img: banner3,
    title: 'Nuestros productos',
    subtitle: 'Nuestros productos cumplen con estándares nacionales e internacionales, consolidándonos como un aliado estratégico y confiable para el sector industrial.',
    boton: 'Ver productos',
    link: '/productos'
  },
  {
    img: banner1,
    title: 'Quiénes somos',
    subtitle: 'Una empresa Colombiana dedicada a la producción, comercialización y distrubución de papeles...',
    boton: 'Conócenos',
    link: '/somos'
  }
];

function HeroSlider() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 8000); // 🔥 más suave y elegante

    return () => clearInterval(interval);
  }, []);

  const prev = () => {
    setIndex(index === 0 ? slides.length - 1 : index - 1);
  };

  const next = () => {
    setIndex((index + 1) % slides.length);
  };

  const current = slides[index];

  return (
    <div className="slider" id="inicio">

      {/* Imagen */}
      <img key={index}  src={current.img} alt="banner" className="slider-img zoom"/>

      {/* Overlay */}
      <div className="overlay"></div>

      {/* CONTENIDO */}
      {current.tipo === 'corporativo' ? (
        <div className="content corporativo">

          {/* IZQUIERDA */}
          <div className="left-block">
            <img src={logo} alt="logo" className="logo-big" />
            <p className="company-name">COMPAÑÍA PAPELERA DE COLOMBIA</p>
          </div>

          {/* LÍNEA */}
          <div className="divider"></div>

          {/* DERECHA */}
          <div className="right-text">
            "SEGURIDAD, SOSTENIBILIDAD<br />
            Y CALIDAD"
          </div>

        </div>
      ) : (
        <div className="content">
          <div className="fade-inner">
            <h1>{current.title}</h1>
            <p>{current.subtitle}</p>

            <Link to={current.link} className="btn">
              {current.boton}
            </Link>
          </div>
        </div>
      )}

      {/* Flechas */}
      <button className="left" onClick={prev}>‹</button>
      <button className="right" onClick={next}>›</button>

    </div>
  );
}

export default HeroSlider;